import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-email",
  "use": "various-email-usage",
  "viewBox": "0 0 22 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 14\" id=\"various-email\"><g fill=\"#e3000f\" fill-rule=\"evenodd\"><path d=\"M0 0l11 8 11-8z\" /><path d=\"M0 2l11 8 11-8v12H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol